<template>
  <div class="tab-section">
    <div class="tab-wrapper">
      <v-btn :class="['tab-btn', { 'tab-active': type === 'STORE' }]" @click="$emit('update:type', 'STORE')" depressed>
        매장
      </v-btn>
      <v-btn
        :class="['tab-btn', { 'tab-active': type === 'PRODUCT' }]"
        @click="$emit('update:type', 'PRODUCT')"
        depressed>
        제품
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeadFormTabs',

  props: {
    type: {
      type: String,
      required: true,
      validator: value => ['STORE', 'PRODUCT'].includes(value),
    },
  },
};
</script>

<style scoped lang="scss">
/* 공통 기본 스타일 */
.tab-section {
  .tab-wrapper {
    display: flex;
    gap: 8px;
    padding: 4px;
    background: var(--disabled_light, #f5f5f5);
    border-radius: 12px;
  }

  .tab-btn {
    // height: 34px;
    font-family: 'Spoqa Han Sans Neo';
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: var(--default, #3a3a3a);
    display: flex;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
    background: transparent !important;
    border-radius: 8px !important;
    box-shadow: none !important;
    text-transform: none;
    letter-spacing: 0;

    &.tab-active {
      background: #ffffff !important;
      color: #ea2a3a;
      box-shadow: 0px 9px 24px rgba(0, 0, 0, 0.1) !important;
    }
  }
}
</style>
